import React from 'react';

import { Col, Flex, Image, Row, Typography } from 'antd';

const LABEL_PREVIEW_SIZE = 80;

const DetailField = ({ label, value }: { label: string; value: string }) => (
  <Col>
    <Flex vertical gap="0.125rem">
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {label}
      </Typography.Text>
      <Typography.Text>{value}</Typography.Text>
    </Flex>
  </Col>
);

const LabelPreview = ({ url }: { url: string }) => (
  <Image
    src={url}
    width={LABEL_PREVIEW_SIZE}
    style={{ border: '1px solid #d9d9d9', borderRadius: 4, cursor: 'pointer' }}
    alt="Label preview"
    preview={{ mask: 'View label' }}
  />
);

interface IParcelDetailsSummaryProps {
  carrier?: string;
  weightInGrams: string;
  carrierTrackingCode?: string;
  labelUrl?: string | null;
}

const ParcelDetailsSummary = ({
  carrier = '-',
  weightInGrams,
  carrierTrackingCode = '-',
  labelUrl,
}: IParcelDetailsSummaryProps) => (
  <Flex justify="space-between" align="flex-start">
    <Row gutter={[24, 8]}>
      <DetailField label="Carrier code" value={carrier} />
      <DetailField label="Carrier tracking code" value={carrierTrackingCode} />
      <DetailField
        label="Weight"
        value={weightInGrams ? `${weightInGrams} kg` : '-'}
      />
    </Row>
    {labelUrl && <LabelPreview url={labelUrl} />}
  </Flex>
);

export { ParcelDetailsSummary, DetailField, LabelPreview };
